import dataset1 from "./humanoid-robot-companies-by-country.json";
import dataset2 from "./humanoid-robot-price-distribution.json";
import dataset3 from "./humanoid-robot-price-vs-height.json";
import dataset4 from "./humanoid-robot-payload-vs-weight.json";
import dataset5 from "./humanoid-robot-battery-runtime.json";
import dataset6 from "./humanoid-robot-degrees-of-freedom.json";
import dataset7 from "./humanoid-robot-sensors-comparison.json";
import dataset8 from "./humanoid-robot-hands-comparison.json";
import dataset9 from "./humanoid-robot-availability.json";
import dataset10 from "./humanoid-robot-deployment-timeline.json";
import dataset11 from "./humanoid-robot-production-vs-deliveries.json";
import dataset12 from "./humanoid-robot-company-funding.json";
import dataset13 from "./humanoid-robot-use-cases-data.json";
import dataset14 from "./humanoid-robot-failure-modes.json";
import dataset15 from "./humanoid-robot-operating-cycle.json";
import dataset16 from "./humanoid-robot-cost-per-task.json";
import dataset17 from "./humanoid-robot-training-data-pipeline.json";
import dataset18 from "./humanoid-robot-task-success-curve.json";
import dataset19 from "./humanoid-robot-hardware-stack.json";
import dataset20 from "./humanoid-robot-reliability-curve.json";
import infographicIndex from './index.json';

export const humanoidInfographicIndex = infographicIndex;
export const humanoidInfographicDatasets = [dataset1, dataset2, dataset3, dataset4, dataset5, dataset6, dataset7, dataset8, dataset9, dataset10, dataset11, dataset12, dataset13, dataset14, dataset15, dataset16, dataset17, dataset18, dataset19, dataset20];
export const humanoidInfographicBySlug = Object.fromEntries(humanoidInfographicDatasets.map((item) => [item.slug, item]));
export const humanoidInfographicSlugs = humanoidInfographicDatasets.map((item) => item.slug);
